<div class="page">
  <div class="subheader">
    <i class="subicon icon-angle-double-left" (click)="order.closeSidebar()"></i>
    <i class="usericon icon-ad_units-F"></i
    ><span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DelinoOfflineFactor.TitleHeader" | translate }} </span>
  </div>

  <div class="content">
    <div class="box">
      <div class="offline-factor-box">
        <ssg-input
          class="conent-box"
          textType="text"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DelinoOfflineFactor.DelinoFactorId' | translate"
          name="WebId"
          [group]="formGroup"
          isNumberOnly="true"></ssg-input>
        <ssg-button
          class="delinofactor"
          (click)="SaveDelinoFactor()"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DelinoOfflineFactor.SaveDelinoId' | translate">
        </ssg-button>
      </div>
      <div class="payment-method-box" style="display: block">
        <ssg-select
          [dataList]="PaymentTypeData"
          [required]="true"
          id="DelinoPaymentMethod"
          name="DelinoPaymentMethod"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DelinoOfflineFactor.PaymentMethod' | translate"
          textFieldName="Title"
          valueFieldName="Id"
          (valueChange)="onDelinoPaymentMethodChanges()">
        </ssg-select>
      </div>
    </div>
  </div>
</div>
